import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["service"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ANNOUNCEMENT } from '../actions/constants';
var MAINTENANCE = 'MAINTENANCE'.toLowerCase();
var ENCRYPTION = 'ENCRYPTION'.toLowerCase();
var ADDRESS_SERVER_URL = 'addressServerUrl';
var MAP_SERVER_URL = 'mapServerUrl';
var initialState = {
  maintenance: true,
  // true means it's online, false otherwise
  encryption: false,
  addressServerUrl: undefined,
  status: {
    maintenance: 'initial',
    encryption: 'initial',
    addressServerUrl: 'initial',
    mapServerUrl: 'initial'
  }
};

var announcementReducer = function announcementReducer(services) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if ((action === null || action === void 0 ? void 0 : action.type) !== ANNOUNCEMENT) {
      return state;
    }

    var _action$payload = action.payload,
        announcementService = _action$payload.service,
        body = _objectWithoutProperties(_action$payload, _excluded);

    if (!services.includes(announcementService)) {
      return state;
    }

    switch (body === null || body === void 0 ? void 0 : body.channel) {
      case MAINTENANCE:
      case ENCRYPTION:
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty(_defineProperty({}, body.channel, body.status), "status", _objectSpread(_objectSpread({}, state.status), {}, _defineProperty({}, body.channel, 'fetched'))));

      case ADDRESS_SERVER_URL:
      case MAP_SERVER_URL:
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty(_defineProperty({}, body.channel, body.url), "status", _objectSpread(_objectSpread({}, state.status), {}, _defineProperty({}, body.channel, 'fetched'))));

      default:
        return state;
    }
  };
};

export default announcementReducer;
//# sourceMappingURL=announcement.js.map